"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errors = void 0;
const core_1 = require("@smash-sdk/core");
const CreateDomainError_1 = require("./types/CreateDomain/CreateDomainError");
const CreateDomainError_2 = require("./types/CreateDomain/CreateDomainError");
const CreateDomainError_3 = require("./types/CreateDomain/CreateDomainError");
const CreateDomainError_4 = require("./types/CreateDomain/CreateDomainError");
const CreateDomainError_5 = require("./types/CreateDomain/CreateDomainError");
const CreateDomainError_6 = require("./types/CreateDomain/CreateDomainError");
const CreateDomainError_7 = require("./types/CreateDomain/CreateDomainError");
const CreateDomainError_8 = require("./types/CreateDomain/CreateDomainError");
const DeleteDomainError_1 = require("./types/DeleteDomain/DeleteDomainError");
const DeleteDomainError_2 = require("./types/DeleteDomain/DeleteDomainError");
const DeleteDomainError_3 = require("./types/DeleteDomain/DeleteDomainError");
const DeleteDomainError_4 = require("./types/DeleteDomain/DeleteDomainError");
const DeleteDomainError_5 = require("./types/DeleteDomain/DeleteDomainError");
const DeleteDomainError_6 = require("./types/DeleteDomain/DeleteDomainError");
const DeleteDomainError_7 = require("./types/DeleteDomain/DeleteDomainError");
const DeleteDomainError_8 = require("./types/DeleteDomain/DeleteDomainError");
const DeleteDomainCustomizationError_1 = require("./types/DeleteDomainCustomization/DeleteDomainCustomizationError");
const DeleteDomainCustomizationError_2 = require("./types/DeleteDomainCustomization/DeleteDomainCustomizationError");
const DeleteDomainCustomizationError_3 = require("./types/DeleteDomainCustomization/DeleteDomainCustomizationError");
const DeleteDomainCustomizationError_4 = require("./types/DeleteDomainCustomization/DeleteDomainCustomizationError");
const DeleteDomainCustomizationError_5 = require("./types/DeleteDomainCustomization/DeleteDomainCustomizationError");
const DeleteDomainCustomizationError_6 = require("./types/DeleteDomainCustomization/DeleteDomainCustomizationError");
const DeleteDomainCustomizationError_7 = require("./types/DeleteDomainCustomization/DeleteDomainCustomizationError");
const GetDomainError_1 = require("./types/GetDomain/GetDomainError");
const GetDomainError_2 = require("./types/GetDomain/GetDomainError");
const GetDomainError_3 = require("./types/GetDomain/GetDomainError");
const GetDomainError_4 = require("./types/GetDomain/GetDomainError");
const GetDomainError_5 = require("./types/GetDomain/GetDomainError");
const GetDomainError_6 = require("./types/GetDomain/GetDomainError");
const GetDomainError_7 = require("./types/GetDomain/GetDomainError");
const GetDomainCustomizationError_1 = require("./types/GetDomainCustomization/GetDomainCustomizationError");
const GetDomainCustomizationError_2 = require("./types/GetDomainCustomization/GetDomainCustomizationError");
const GetDomainCustomizationError_3 = require("./types/GetDomainCustomization/GetDomainCustomizationError");
const GetDomainCustomizationError_4 = require("./types/GetDomainCustomization/GetDomainCustomizationError");
const GetDomainCustomizationError_5 = require("./types/GetDomainCustomization/GetDomainCustomizationError");
const GetDomainCustomizationError_6 = require("./types/GetDomainCustomization/GetDomainCustomizationError");
const GetDomainCustomizationError_7 = require("./types/GetDomainCustomization/GetDomainCustomizationError");
const GetRecordError_1 = require("./types/GetRecord/GetRecordError");
const GetRecordError_2 = require("./types/GetRecord/GetRecordError");
const GetRecordError_3 = require("./types/GetRecord/GetRecordError");
const GetRecordError_4 = require("./types/GetRecord/GetRecordError");
const GetRecordError_5 = require("./types/GetRecord/GetRecordError");
const GetRecordError_6 = require("./types/GetRecord/GetRecordError");
const ListDomainsError_1 = require("./types/ListDomains/ListDomainsError");
const ListDomainsError_2 = require("./types/ListDomains/ListDomainsError");
const ListDomainsError_3 = require("./types/ListDomains/ListDomainsError");
const ListDomainsError_4 = require("./types/ListDomains/ListDomainsError");
const ListDomainsError_5 = require("./types/ListDomains/ListDomainsError");
const ListRecordProvidersError_1 = require("./types/ListRecordProviders/ListRecordProvidersError");
const ListRecordProvidersError_2 = require("./types/ListRecordProviders/ListRecordProvidersError");
const ListRecordProvidersError_3 = require("./types/ListRecordProviders/ListRecordProvidersError");
const ListRecordProvidersError_4 = require("./types/ListRecordProviders/ListRecordProvidersError");
const ListRecordProvidersError_5 = require("./types/ListRecordProviders/ListRecordProvidersError");
const ListRecordProvidersError_6 = require("./types/ListRecordProviders/ListRecordProvidersError");
const UpdateDomainError_1 = require("./types/UpdateDomain/UpdateDomainError");
const UpdateDomainError_2 = require("./types/UpdateDomain/UpdateDomainError");
const UpdateDomainError_3 = require("./types/UpdateDomain/UpdateDomainError");
const UpdateDomainError_4 = require("./types/UpdateDomain/UpdateDomainError");
const UpdateDomainError_5 = require("./types/UpdateDomain/UpdateDomainError");
const UpdateDomainError_6 = require("./types/UpdateDomain/UpdateDomainError");
const UpdateDomainError_7 = require("./types/UpdateDomain/UpdateDomainError");
const UpdateDomainError_8 = require("./types/UpdateDomain/UpdateDomainError");
const UpdateDomainError_9 = require("./types/UpdateDomain/UpdateDomainError");
const UpdateDomainError_10 = require("./types/UpdateDomain/UpdateDomainError");
const UpdateDomainCustomizationError_1 = require("./types/UpdateDomainCustomization/UpdateDomainCustomizationError");
const UpdateDomainCustomizationError_2 = require("./types/UpdateDomainCustomization/UpdateDomainCustomizationError");
const UpdateDomainCustomizationError_3 = require("./types/UpdateDomainCustomization/UpdateDomainCustomizationError");
const UpdateDomainCustomizationError_4 = require("./types/UpdateDomainCustomization/UpdateDomainCustomizationError");
const UpdateDomainCustomizationError_5 = require("./types/UpdateDomainCustomization/UpdateDomainCustomizationError");
const UpdateDomainCustomizationError_6 = require("./types/UpdateDomainCustomization/UpdateDomainCustomizationError");
const UpdateDomainCustomizationError_7 = require("./types/UpdateDomainCustomization/UpdateDomainCustomizationError");
exports.errors = {
    CreateDomain: {
        InvalidParameterError: CreateDomainError_2.InvalidParameterError,
        UnauthorizedError: CreateDomainError_3.UnauthorizedError,
        InvalidSubscriptionError: CreateDomainError_4.InvalidSubscriptionError,
        DomainAlreadyExistError: CreateDomainError_5.DomainAlreadyExistError,
        InternalServerError: CreateDomainError_6.InternalServerError,
        BadGatewayError: CreateDomainError_7.BadGatewayError,
        GatewayTimeoutError: CreateDomainError_8.GatewayTimeoutError,
        GenericError: CreateDomainError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    DeleteDomain: {
        InvalidParameterError: DeleteDomainError_2.InvalidParameterError,
        UnauthorizedError: DeleteDomainError_3.UnauthorizedError,
        DomainIsCNameError: DeleteDomainError_4.DomainIsCNameError,
        NotFoundError: DeleteDomainError_5.NotFoundError,
        InternalServerError: DeleteDomainError_6.InternalServerError,
        BadGatewayError: DeleteDomainError_7.BadGatewayError,
        GatewayTimeoutError: DeleteDomainError_8.GatewayTimeoutError,
        GenericError: DeleteDomainError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    DeleteDomainCustomization: {
        InvalidParameterError: DeleteDomainCustomizationError_2.InvalidParameterError,
        UnauthorizedError: DeleteDomainCustomizationError_3.UnauthorizedError,
        NotFoundError: DeleteDomainCustomizationError_4.NotFoundError,
        InternalServerError: DeleteDomainCustomizationError_5.InternalServerError,
        BadGatewayError: DeleteDomainCustomizationError_6.BadGatewayError,
        GatewayTimeoutError: DeleteDomainCustomizationError_7.GatewayTimeoutError,
        GenericError: DeleteDomainCustomizationError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetDomain: {
        InvalidParameterError: GetDomainError_2.InvalidParameterError,
        UnauthorizedError: GetDomainError_3.UnauthorizedError,
        NotFoundError: GetDomainError_4.NotFoundError,
        InternalServerError: GetDomainError_5.InternalServerError,
        BadGatewayError: GetDomainError_6.BadGatewayError,
        GatewayTimeoutError: GetDomainError_7.GatewayTimeoutError,
        GenericError: GetDomainError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetDomainCustomization: {
        InvalidParameterError: GetDomainCustomizationError_2.InvalidParameterError,
        UnauthorizedError: GetDomainCustomizationError_3.UnauthorizedError,
        NotFoundError: GetDomainCustomizationError_4.NotFoundError,
        InternalServerError: GetDomainCustomizationError_5.InternalServerError,
        BadGatewayError: GetDomainCustomizationError_6.BadGatewayError,
        GatewayTimeoutError: GetDomainCustomizationError_7.GatewayTimeoutError,
        GenericError: GetDomainCustomizationError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetRecord: {
        InvalidParameterError: GetRecordError_2.InvalidParameterError,
        NotFoundError: GetRecordError_3.NotFoundError,
        InternalServerError: GetRecordError_4.InternalServerError,
        BadGatewayError: GetRecordError_5.BadGatewayError,
        GatewayTimeoutError: GetRecordError_6.GatewayTimeoutError,
        GenericError: GetRecordError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListDomains: {
        UnauthorizedError: ListDomainsError_2.UnauthorizedError,
        InternalServerError: ListDomainsError_3.InternalServerError,
        BadGatewayError: ListDomainsError_4.BadGatewayError,
        GatewayTimeoutError: ListDomainsError_5.GatewayTimeoutError,
        GenericError: ListDomainsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListRecordProviders: {
        InvalidParameterError: ListRecordProvidersError_2.InvalidParameterError,
        NotFoundError: ListRecordProvidersError_3.NotFoundError,
        InternalServerError: ListRecordProvidersError_4.InternalServerError,
        BadGatewayError: ListRecordProvidersError_5.BadGatewayError,
        GatewayTimeoutError: ListRecordProvidersError_6.GatewayTimeoutError,
        GenericError: ListRecordProvidersError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    UpdateDomain: {
        InvalidParameterError: UpdateDomainError_2.InvalidParameterError,
        UnauthorizedError: UpdateDomainError_3.UnauthorizedError,
        InvalidSubscriptionError: UpdateDomainError_4.InvalidSubscriptionError,
        DomainIsCNameError: UpdateDomainError_5.DomainIsCNameError,
        NotFoundError: UpdateDomainError_6.NotFoundError,
        DomainAlreadyExistError: UpdateDomainError_7.DomainAlreadyExistError,
        InternalServerError: UpdateDomainError_8.InternalServerError,
        BadGatewayError: UpdateDomainError_9.BadGatewayError,
        GatewayTimeoutError: UpdateDomainError_10.GatewayTimeoutError,
        GenericError: UpdateDomainError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    UpdateDomainCustomization: {
        InvalidParameterError: UpdateDomainCustomizationError_2.InvalidParameterError,
        UnauthorizedError: UpdateDomainCustomizationError_3.UnauthorizedError,
        NotFoundError: UpdateDomainCustomizationError_4.NotFoundError,
        InternalServerError: UpdateDomainCustomizationError_5.InternalServerError,
        BadGatewayError: UpdateDomainCustomizationError_6.BadGatewayError,
        GatewayTimeoutError: UpdateDomainCustomizationError_7.GatewayTimeoutError,
        GenericError: UpdateDomainCustomizationError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    CreateDomainError: {
        InvalidParameterError: CreateDomainError_2.InvalidParameterError,
        UnauthorizedError: CreateDomainError_3.UnauthorizedError,
        InvalidSubscriptionError: CreateDomainError_4.InvalidSubscriptionError,
        DomainAlreadyExistError: CreateDomainError_5.DomainAlreadyExistError,
        InternalServerError: CreateDomainError_6.InternalServerError,
        BadGatewayError: CreateDomainError_7.BadGatewayError,
        GatewayTimeoutError: CreateDomainError_8.GatewayTimeoutError,
        GenericError: CreateDomainError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    DeleteDomainError: {
        InvalidParameterError: DeleteDomainError_2.InvalidParameterError,
        UnauthorizedError: DeleteDomainError_3.UnauthorizedError,
        DomainIsCNameError: DeleteDomainError_4.DomainIsCNameError,
        NotFoundError: DeleteDomainError_5.NotFoundError,
        InternalServerError: DeleteDomainError_6.InternalServerError,
        BadGatewayError: DeleteDomainError_7.BadGatewayError,
        GatewayTimeoutError: DeleteDomainError_8.GatewayTimeoutError,
        GenericError: DeleteDomainError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    DeleteDomainCustomizationError: {
        InvalidParameterError: DeleteDomainCustomizationError_2.InvalidParameterError,
        UnauthorizedError: DeleteDomainCustomizationError_3.UnauthorizedError,
        NotFoundError: DeleteDomainCustomizationError_4.NotFoundError,
        InternalServerError: DeleteDomainCustomizationError_5.InternalServerError,
        BadGatewayError: DeleteDomainCustomizationError_6.BadGatewayError,
        GatewayTimeoutError: DeleteDomainCustomizationError_7.GatewayTimeoutError,
        GenericError: DeleteDomainCustomizationError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetDomainError: {
        InvalidParameterError: GetDomainError_2.InvalidParameterError,
        UnauthorizedError: GetDomainError_3.UnauthorizedError,
        NotFoundError: GetDomainError_4.NotFoundError,
        InternalServerError: GetDomainError_5.InternalServerError,
        BadGatewayError: GetDomainError_6.BadGatewayError,
        GatewayTimeoutError: GetDomainError_7.GatewayTimeoutError,
        GenericError: GetDomainError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetDomainCustomizationError: {
        InvalidParameterError: GetDomainCustomizationError_2.InvalidParameterError,
        UnauthorizedError: GetDomainCustomizationError_3.UnauthorizedError,
        NotFoundError: GetDomainCustomizationError_4.NotFoundError,
        InternalServerError: GetDomainCustomizationError_5.InternalServerError,
        BadGatewayError: GetDomainCustomizationError_6.BadGatewayError,
        GatewayTimeoutError: GetDomainCustomizationError_7.GatewayTimeoutError,
        GenericError: GetDomainCustomizationError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetRecordError: {
        InvalidParameterError: GetRecordError_2.InvalidParameterError,
        NotFoundError: GetRecordError_3.NotFoundError,
        InternalServerError: GetRecordError_4.InternalServerError,
        BadGatewayError: GetRecordError_5.BadGatewayError,
        GatewayTimeoutError: GetRecordError_6.GatewayTimeoutError,
        GenericError: GetRecordError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListDomainsError: {
        UnauthorizedError: ListDomainsError_2.UnauthorizedError,
        InternalServerError: ListDomainsError_3.InternalServerError,
        BadGatewayError: ListDomainsError_4.BadGatewayError,
        GatewayTimeoutError: ListDomainsError_5.GatewayTimeoutError,
        GenericError: ListDomainsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListRecordProvidersError: {
        InvalidParameterError: ListRecordProvidersError_2.InvalidParameterError,
        NotFoundError: ListRecordProvidersError_3.NotFoundError,
        InternalServerError: ListRecordProvidersError_4.InternalServerError,
        BadGatewayError: ListRecordProvidersError_5.BadGatewayError,
        GatewayTimeoutError: ListRecordProvidersError_6.GatewayTimeoutError,
        GenericError: ListRecordProvidersError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    UpdateDomainError: {
        InvalidParameterError: UpdateDomainError_2.InvalidParameterError,
        UnauthorizedError: UpdateDomainError_3.UnauthorizedError,
        InvalidSubscriptionError: UpdateDomainError_4.InvalidSubscriptionError,
        DomainIsCNameError: UpdateDomainError_5.DomainIsCNameError,
        NotFoundError: UpdateDomainError_6.NotFoundError,
        DomainAlreadyExistError: UpdateDomainError_7.DomainAlreadyExistError,
        InternalServerError: UpdateDomainError_8.InternalServerError,
        BadGatewayError: UpdateDomainError_9.BadGatewayError,
        GatewayTimeoutError: UpdateDomainError_10.GatewayTimeoutError,
        GenericError: UpdateDomainError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    UpdateDomainCustomizationError: {
        InvalidParameterError: UpdateDomainCustomizationError_2.InvalidParameterError,
        UnauthorizedError: UpdateDomainCustomizationError_3.UnauthorizedError,
        NotFoundError: UpdateDomainCustomizationError_4.NotFoundError,
        InternalServerError: UpdateDomainCustomizationError_5.InternalServerError,
        BadGatewayError: UpdateDomainCustomizationError_6.BadGatewayError,
        GatewayTimeoutError: UpdateDomainCustomizationError_7.GatewayTimeoutError,
        GenericError: UpdateDomainCustomizationError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    InvalidSdkConfigurationError: core_1.InvalidSdkConfigurationError,
    InvalidRegionOrHostError: core_1.InvalidRegionOrHostError,
    InvalidRegionError: core_1.InvalidRegionError,
    InvalidHostError: core_1.InvalidHostError,
};
